module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.inv && _vm.inv.paid) ? _c('div', [_c('div', {
    staticClass: "columns border-bottom-lg"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [(_vm.brand === 'pl') ? _c('img', {
    staticClass: "invoiceLogo",
    attrs: {
      "src": require("../../assets/pocketlegal_logo.png"),
      "alt": "PocketLegal"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('img', {
    staticClass: "invoiceLogo",
    attrs: {
      "src": require("../../assets/immiexperts.png"),
      "alt": "Immigration Experts"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.brand === 'pl') ? _c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n        PocketLegal Pty Ltd"), _c('br'), _vm._v("\n        162 Redfern Street"), _c('br'), _vm._v("\n        Redfern 2016, NSW"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:accounts@pocketlegal.com.au"
    }
  }, [_vm._v("accounts@pocketlegal.com.au")]), _c('br'), _vm._v("\n        Phone: (02) 8385 1451"), _c('br'), _vm._v("\n        ABN: 12 613 908 124"), _c('br'), _vm._v("\n        ACN: 613 908 124\n      ")]) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n        Immigration Experts Pty Ltd"), _c('br'), _vm._v("\n        162 Redfern Street"), _c('br'), _vm._v("\n        Redfern 2016, NSW"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@immiexperts.com.au"
    }
  }, [_vm._v("info@immiexperts.com.au")]), _c('br'), _vm._v("\n        Phone: (02) 9279 1289"), _c('br'), _vm._v("\n        ABN: 12 613 908 124"), _c('br'), _vm._v("\n        ACN: 613 908 124\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "columns border-bottom-lg"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Reference")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v(_vm._s(_vm.inv.ref))]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Client")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v(_vm._s(_vm.inv.business ? _vm.inv.business : _vm.inv.firstname + ' ' + _vm.inv.lastname))]), _vm._v(" "), (_vm.inv.business) ? _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Attn")]) : _vm._e(), _vm._v(" "), (_vm.inv.business) ? _c('div', {
    staticClass: "column col-8"
  }, [_vm._v(_vm._s(_vm.inv.firstname) + " " + _vm._s(_vm.inv.lastname))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Invoice date")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v(_vm._s(_vm.date(_vm.inv.date)))]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Invoice status")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Paid " + _vm._s(_vm.paymentDate(_vm.inv)))])])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-lg"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_c('h2', [_vm._v("Description")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.inv.matter_desc))])])]), _vm._v(" "), _vm._l((_vm.inv.items), function(item) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-4"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('div', {
      staticClass: "column col-8"
    }, [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))])])
  }), _vm._v(" "), (_vm.inv.gst) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("GST (10%)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v("$" + _vm._s(_vm.c2d(_vm.inv.gst)))])]) : _vm._e(), _vm._v(" "), (_vm.inv.surcharge) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Surcharge (1.4%)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v("$" + _vm._s(_vm.c2d(_vm.inv.surcharge)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "column col-8"
  }, [_vm._v("$" + _vm._s(_vm.c2d(_vm.inv.total)))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "columns border-bottom-sm invoicePrint"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_c('button', {
    staticClass: "btn bg-gray",
    on: {
      "click": _vm.print
    }
  }, [_vm._v("Print this page")])])]), _vm._v(" "), (_vm.inv.plan) ? _c('div', {
    staticClass: "paymentPlanTable"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_vm._m(1), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Monthly payment amount: $" + _vm._s(_vm.c2d(_vm.inv.monthly)))]), _vm._v(" "), _c('th', [_vm._v("Remaining: $" + _vm._s(_vm.c2d(_vm.inv.outstanding)))]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.payments(_vm.inv)), function(payment) {
    return _c('tr', [(_vm.inv.last_payment) ? _c('td', [_vm._v(_vm._s(payment.date))]) : _c('td', [_vm._v("Upcoming")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(payment.amount)))]), _vm._v(" "), _c('td', [(payment.paid) ? _c('span', {
      staticClass: "label label-rounded label-success"
    }, [_vm._v("Paid")]) : _c('span', {
      staticClass: "label label-rounded label-warning"
    }, [_vm._v("Scheduled")])])])
  }), 0)])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-6 text-right"
  }, [_c('h1', [_vm._v("Receipt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h4', [_vm._v("Your payment plan")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Monthly amount")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77348cc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/receipt.vue
// module id = 509
// module chunks = 1